module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cc-1e4d4d1f942f29730ff8ecee51ccedbc.svg";